import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

// Production aur Localhost ke liye sahi BASE_URL configuration
const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8002'
    : 'https://likaiev.com';

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        const fetchGallery = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/products/`);
                const productList = Array.isArray(response.data) ? response.data : response.data.results || [];
                const allImages = [];

                productList.forEach(product => {
                    if (product.images && Array.isArray(product.images)) {
                        product.images.forEach(imgObj => {
                            let imgUrl = imgObj.image;
                            if (imgUrl) {
                                // Backend IP/port ko hata kar relative path ya BASE_URL set karna
                                if (imgUrl.includes('66.116.250.115:8002') || imgUrl.includes('127.0.0.1')) {
                                    imgUrl = imgUrl.replace(/http:\/\/[^/]+/, BASE_URL);
                                } else if (!imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
                                    imgUrl = `${BASE_URL}${imgUrl}`;
                                }
                                allImages.push({ src: imgUrl, title: product.title });
                            }
                        });
                    }
                });

                setImages(allImages);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching gallery:", error);
                setImages([]);
                setLoading(false);
            }
        };

        fetchGallery();
    }, []);

    return (
        <div className="bg-gray-50 min-h-screen">
            <div
                className="relative h-[350px] w-full flex items-center justify-center mb-16 overflow-hidden bg-cover bg-center"
                style={{ backgroundImage: "url('/banner1.jpg')" }}
            >
                <div className="absolute inset-0 bg-blue-900/70"></div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="relative z-10 text-center px-4"
                >
                    <h1 className="text-5xl md:text-6xl font-extrabold text-white tracking-wider mb-4">OUR GALLERY</h1>
                    <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
                    <p className="text-blue-100 mt-4 text-lg">Explore our product certifications and quality standards.</p>
                </motion.div>
            </div>

            <div className="container mx-auto px-6 pb-20">
                {loading ? (
                    <div className="text-center text-xl font-bold py-20">Loading Gallery...</div>
                ) : images.length === 0 ? (
                    <div className="text-center text-xl text-gray-500 py-20">No images found.</div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                        {images.map((item, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.05 }}
                                onClick={() => setSelectedImage(item)}
                                className="bg-white p-4 rounded-xl shadow-lg cursor-pointer border border-gray-100"
                            >
                                <img
                                    src={item.src}
                                    alt={item.title}
                                    className="w-full h-64 object-cover rounded-lg"
                                />
                                <p className="mt-4 text-center font-semibold text-gray-700">{item.title}</p>
                            </motion.div>
                        ))}
                    </div>
                )}
            </div>

            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedImage(null)}
                        className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                    >
                        <motion.img
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            src={selectedImage.src}
                            alt="Zoomed"
                            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                        />
                        <button
                            className="absolute top-5 right-5 text-white text-3xl font-bold"
                            onClick={() => setSelectedImage(null)}
                        >
                            &times;
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default Gallery;